/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SwaggerResourceSchemaResponse {
    getFixupPrototypeFunction() { return SwaggerResourceSchemaResponse.fixupPrototype; }

    static newInstance(model: Partial<SwaggerResourceSchemaResponse>): SwaggerResourceSchemaResponse {
        let obj = Object.assign(new SwaggerResourceSchemaResponse(), model);
        SwaggerResourceSchemaResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SwaggerResourceSchemaResponse>): SwaggerResourceSchemaResponse {
        if (!model) return null;
        return SwaggerResourceSchemaResponse.newInstance(<SwaggerResourceSchemaResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SwaggerResourceSchemaResponse) {
        if (!obj) return;

        models.SwaggerResourceSchemaResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SwaggerResourceSchemaResponse): boolean {
        Object.setPrototypeOf(obj, SwaggerResourceSchemaResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let val of this.results) {
                models.SwaggerResource.fixupPrototype(val);
            }
        }
    }

    /**
     * Resource List
     */
    results: Array<models.SwaggerResource>;

}
